module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"es":{"text":["Presentamos la solución Hosted Payments by Snap*. Con esta solución de UniversalPay podrás aceptar el pago con tarjeta de manera rápida y segura.","Activa la solución en tu tienda Magento y podrás mostrar un formulario de pago tanto como redirección como solución integrada en iFrame."],"btn":"VER PLUGIN","text1":"Para cualquier duda o comentario escribe a "}}')
  delete Component.options._Ctor
}
